// extracted by mini-css-extract-plugin
export var totalisationFieldsContainer = "S-H7gTtR";